import React, { Component } from 'react';
import { connect } from 'react-redux';
import { getTranslate, getActiveLanguage } from 'react-localize-redux';

import PageBase from 'components/common/PageBase';
import DetailsPage from 'containers/detailsPage/DetailsPage';

class ICNPageDetails extends Component {
    render() {
        const { translate} = this.props;

        return (
            <PageBase title={translate('ICNForm.detailsTitle')} showGoToButtons={true} showDownloadButtons={true} id={this.props.params.id} isIcnPlus={false} isDent={false}  >
                <DetailsPage id={this.props.params.id} isIcnPlus={false} isDent={false} />
            </PageBase>
        );
    }
}

function mapStateToProps(state, ownProps) {
    return {
        translate: getTranslate(state.locale),
        currentLanguage: getActiveLanguage(state.locale).code
    };
}


export default connect(mapStateToProps)(ICNPageDetails);


// WEBPACK FOOTER //
// ./src/pages/icn/ICNPageDetails.js